type SseEventHandler = (data: unknown) => void

let handlers = new Map<string, Set<SseEventHandler>>()

export function resetSseEventBusForTests() {
    handlers = new Map()
}

export function subscribeSseEvent(eventName: string, handler: SseEventHandler) {
    if (!handlers.has(eventName)) {
        handlers.set(eventName, new Set())
    }
    handlers.get(eventName)!.add(handler)
    return () => {
        handlers.get(eventName)?.delete(handler)
    }
}

export function dispatchSseEvent(eventName: string, data: unknown) {
    const eventHandlers = handlers.get(eventName)
    if (!eventHandlers) {
        return
    }
    for (const handler of eventHandlers) {
        try {
            handler(data)
        }
        catch {
            // ignore handler errors
        }
    }
}
